// extracted by mini-css-extract-plugin
export default {"title":"zaa-z","warning":"Aaa-z","sizeOptionsLegendText":"Baa-z"};